module.exports = __webpack_public_path__ + "static/media/sub_about_guidingstudents.a6c365f4.png";